import { render, staticRenderFns } from "./FormSolicitudArrendamiento.vue?vue&type=template&id=2a7fec4a&"
import script from "./FormSolicitudArrendamiento.vue?vue&type=script&lang=ts&"
export * from "./FormSolicitudArrendamiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports